import { useAsset } from '@artica/assets';
import {
  DoubleSide,
  EquirectangularReflectionMapping,
} from 'three';

export default function SphereMaterial() {
  const spheremap = useAsset('obsidian_spheremap');
  const spherefalloff = useAsset('orb_albedo');

  spheremap.mapping = EquirectangularReflectionMapping;

  return (
    <meshPhysicalMaterial
      ior={ 1.1 }
      roughness={ 0.02 }
      reflectivity={ 0.8 }
      specularIntensity={ 3 }
      color={ [3, 3, 3] }
      transparent={ true }
      envMap={ spheremap }
      map={ spherefalloff }
      side={ DoubleSide }
      specularIntensityMap={ spherefalloff }
    />
  );
}